import DocumentRelevanceDecisionBar from './DocumentRelevanceDecisionBar.vue'

const DocumentRelevancePresentationVariant = Object.freeze({
    INLINE_SELECT_V1: 'inline-select-v1',
    COMPLETION_RADIO_V1: 'completion-radio-v1',
})

const PRESENTATIONS = Object.freeze({
    [DocumentRelevancePresentationVariant.COMPLETION_RADIO_V1]: DocumentRelevanceDecisionBar,
})

const normalizeConfig = config => (
    config && typeof config === 'object' ? config : {}
)

const resolveDocumentRelevancePresentation = config => (
    PRESENTATIONS[normalizeConfig(config).variant] || null
)

const isDocumentRelevanceRequiredForCompletion = config => (
    normalizeConfig(config).requiredForCompletion === true
)

export {
    DocumentRelevancePresentationVariant,
    isDocumentRelevanceRequiredForCompletion,
    resolveDocumentRelevancePresentation,
}
